// src/config/defaultConfig.ts
import { Config } from '../types/config';

const defaultConfig: Config = {
    _id: 'default',
    name: 'Standardturnier',
    blinds: [
        { smallBlind: 100, bigBlind: 100, ante: 0, duration: 30 },
        { smallBlind: 100, bigBlind: 200, ante: 200, duration: 30 },
        { smallBlind: 200, bigBlind: 300, ante: 300, duration: 30 },
        { smallBlind: 200, bigBlind: 400, ante: 400, duration: 30 },
        { smallBlind: 300, bigBlind: 600, ante: 600, duration: 30 },
        { smallBlind: 400, bigBlind: 800, ante: 800, duration: 30 },
        { smallBlind: 500, bigBlind: 1000, ante: 1000, duration: 30 },
        { smallBlind: 600, bigBlind: 1200, ante: 1200, duration: 30 },
        { smallBlind: 800, bigBlind: 1600, ante: 1600, duration: 30 },
        { smallBlind: 1000, bigBlind: 2000, ante: 2000, duration: 30 },
        { smallBlind: 1200, bigBlind: 2400, ante: 2400, duration: 30 },
        { smallBlind: 1500, bigBlind: 3000, ante: 3000, duration: 30 },
        { smallBlind: 2000, bigBlind: 4000, ante: 4000, duration: 30 },
        { smallBlind: 2500, bigBlind: 5000, ante: 5000, duration: 30 },
        { smallBlind: 3000, bigBlind: 6000, ante: 6000, duration: 30 },
        { smallBlind: 4000, bigBlind: 8000, ante: 8000, duration: 30 },
        { smallBlind: 5000, bigBlind: 10000, ante: 10000, duration: 30 },
        { smallBlind: 6000, bigBlind: 12000, ante: 12000, duration: 30 },
        { smallBlind: 8000, bigBlind: 16000, ante: 16000, duration: 30 },
        { smallBlind: 10000, bigBlind: 20000, ante: 20000, duration: 30 },
    ],
};

export default defaultConfig;
